<div
  class="content row"
  [ngClass]="{
    'col-10 no-border': rights?.includes('SummaryWidgets'),
    'col-12 no-border': !rights?.includes('SummaryWidgets'),
  }"
>
  @if (rights?.includes('SummaryWidgets')) {
    <div class="col-12 row toolbar">
      <mat-form-field class="mb-4">
        <mat-label>Solution</mat-label>
        <mat-select [(ngModel)]="solution">
          @for (sltn of solutions; track sltn.value) {
            <mat-option [value]="sltn.value">
              {{ sltn.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <app-summary-charts class="col-md-8" [solutionId]="solution" />
    <app-cases-by-scoreclass class="col-md-4" [solutionId]="solution" />
    <app-system-usage-summary class="col-12 mt-3" />
    <app-top-5-summary class="col-12 mt-5" [solutionId]="solution" />
  }
  @if (!rights?.includes('SummaryWidgets') && rights?.includes('Launcher')) {
    <app-legacy-app-links class="w-100" />
  }
  @if (rights?.includes('CaseStatsWidget')) {
    <app-case-stats class="col-12" />
  }
  @if (rights?.includes('FundCompareReport')) {
    <app-fund-comparison class="col-12" />
  }
  @if (rights?.includes('HighActivity')) {
    <app-high-activity-stats class="col-12" />
  }
  @if (rights?.includes('UnitProductCaseStats')) {
    <app-unit-product-stats class="col-12" />
  }
  @if (
    rights?.includes('LWRecentActivityWidget') &&
    rights?.includes('LWSummaryWidget')
  ) {
    <app-life-stats class="col-12" />
  }

  @if (rights?.includes('opportunitiesOfTheDayWidget')) {
    <app-top5 class="col-sm-12 col-md-6" />
  }
  @if (rights?.includes('TopOpportunitiesWidget')) {
    <app-top-opps class="col-sm-12 col-md-6 col-xl-4" />
  }
  @if (rights?.includes('TimeSensitiveWidget')) {
    <app-time-sensitive class="col-sm-12 col-md-6" />
  }
  @if (rights?.includes('FollowupWidget')) {
    <app-follow-up class="col-sm-12 col-md-6" />
  }
  @if (rights?.includes('ClientStatisticsWidget')) {
    <app-scorecard class="col-sm-12 col-md-6 col-xl-4" />
  }
  @if (rights?.includes('TopBridgesWidget')) {
    <app-top-bridges class="col-sm-12 col-md-6" />
  }
  @if (rights?.includes('AWDB-FixedRates')) {
    <app-annuities class="col-sm-12 col-md-12 col-xl-12" />
    <app-fixed-annuities-active-rates class="col-sm-12 col-md-12 col-xl-12" />
    <app-fia-rates class="col-sm-12 col-md-12 col-xl-12" />
    <app-fiaactiverates class="col-sm-12 col-md-12 col-xl-12" />
    <app-via-rates class="col-sm-12 col-md-12 col-xl-12" />
    <app-via-active-rates class="col-sm-12 col-md-12 col-xl-12" />
    <app-ppfa class="col-sm-12 col-md-12 col-xl-12" />
    <app-activeppfa class="col-sm-12 col-md-12 col-xl-12" />
    <app-annuities-by-connector class="col-sm-12 col-md-12 col-xl-12" />
    <app-living-benefits class="col-sm-12 col-md-12 col-xl-12" />
    <app-death-benefits class="col-sm-12 col-md-12 col-xl-12" />
  }
  @if (rights?.includes('Upload1040')) {
    <app-uploader class="col-sm-12 col-md-6 col-xl-4" />
  }
  <div class="messages-container">
    @if (hasMessages(1)) {
      <app-messages
        class="col-sm-12 col-md-6 col-xl-4"
        [message]="msgContent[0]"
      />
    }
    @if (hasMessages(2)) {
      <app-messages
        class="col-sm-12 col-md-6 col-xl-4"
        [message]="msgContent[1]"
      />
    }
    @if (hasMessages(3)) {
      <app-messages
        class="col-sm-12 col-md-6 col-xl-4"
        [message]="msgContent[2]"
      />
    }
    @if (hasMessages(4)) {
      <app-messages
        class="col-sm-12 col-md-6 col-xl-4"
        [message]="msgContent[3]"
      />
    }
    @if (hasMessages(5)) {
      <app-messages
        class="col-sm-12 col-md-6 col-xl-4"
        [message]="msgContent[4]"
      />
    }
  </div>
</div>
